module.exports = __webpack_public_path__ + "img/fastjson.60eaa801.svg";